import { CircleCheck } from 'lucide-react';

import { Badge } from '@/ui/primitives/badge';
import { type EmpresaResumo } from '@fiscoai/contracts';

import { PENDENCIA } from './rotulos';

/** Mostra a pendência mais importante e conta as demais (o detalhe lista todas). */
export function PendenciasEmpresa({ empresa }: { empresa: EmpresaResumo }) {
  if (empresa.pendencias.length === 0) {
    return (
      <span className="inline-flex items-center gap-1 text-sm text-sucesso">
        <CircleCheck className="size-3.5" aria-hidden /> Cadastro completo
      </span>
    );
  }
  const [primeira, ...resto] = empresa.pendencias;
  return (
    <span className="flex flex-wrap items-center gap-1">
      {primeira && <Badge tom={PENDENCIA[primeira].tom}>{PENDENCIA[primeira].rotulo}</Badge>}
      {resto.length > 0 && (
        <Badge title={resto.map((p) => PENDENCIA[p].rotulo).join(', ')}>+{resto.length}</Badge>
      )}
    </span>
  );
}
